import React from 'react';
import { Prompt } from '../../types';

interface ContentFlowProps {
  prompt: Prompt;
  onMarkerClick?: ( marker: string) => void;
}

const ContentFlow: React.FC<ContentFlowProps> = ({
  prompt,
  onMarkerClick,
}) => (
 <div
className="
min-h-0
shrink-0
p-4
sm:p-5
space-y-4
"
>
            {prompt.observation && (
              <div className="rounded-xl border border-dark-700 bg-dark-900 p-4 sm:p-5 text-dark-100 shadow-sm">
                <div className="mb-3 text-sm font-semibold text-purple-300">Observação</div>
                <p className="whitespace-pre-wrap text-dark-100 leading-relaxed">
                  {prompt.observation}
                </p>
              </div>
            )}

            <div className="rounded-xl border border-dark-700 bg-dark-900 p-4 sm:p-5 overflow-hidden shadow-sm">
              <div className="mb-3 text-sm font-semibold text-purple-300">Prompt</div>
              <div className="max-h-[50vh]
sm:max-h-72 overflow-y-auto rounded-lg bg-dark-950 p-4">
                <pre className="whitespace-pre-wrap break-words font-mono text-dark-100 leading-relaxed">
                  {prompt.content}
                </pre>
              </div>
            </div>

            {prompt.markers &&
 prompt.markers.length > 0 && (

  <div className="rounded-xl border border-dark-700 bg-dark-900 p-4 sm:p-5 shadow-sm">

    <div className="mb-3 text-sm font-semibold text-purple-300">
      Marcadores
    </div>

    <div className="flex flex-wrap gap-2">

      {prompt.markers.map((marker) => (

        <button
  key={marker}
  type="button"
  onClick={() =>
    onMarkerClick?.(marker)
  }
  className="
    px-3
    py-1
    rounded-full
    bg-purple-900/30
    text-purple-300
    text-sm
    hover:bg-purple-800/40
    transition-colors
    cursor-pointer
  "
>
  #{marker}
</button>

      ))}

    </div>

  </div>

)}

            {prompt.variations && prompt.variations.length > 0 && (
              <div className="rounded-xl border border-dark-700 bg-dark-900 p-4 sm:p-5 overflow-hidden shadow-sm">
                <div className="mb-3 text-sm font-semibold text-purple-300">
                  VariaÃ§Ãµes ({prompt.variations.length})
                </div>
                <div className="space-y-4">
                  {prompt.variations.map((variation, index) => (
                    <div key={index} className="border-l-2 border-purple-500/30 pl-4">
                      <div className="text-xs text-dark-400 mb-1">Var {index + 1}</div>
                      <div className="max-h-48 overflow-y-auto rounded-lg bg-dark-950 p-3">
                        <pre className="whitespace-pre-wrap break-words font-mono text-dark-100 leading-relaxed text-sm">
                          {variation}
                        </pre>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
);

export default ContentFlow;
